import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Tooltip, ShortenedText, Modal, Loader } from '../../../../UiKit';
import {
  highAddressIcon,
  upArrowIconGreen,
  upArrowIcon,
} from '../../../../images/images';
import Shimmer from 'sushiweb/Shimmer';
import { viewText } from '../../../../images/images';
import { userModel } from '../../../../api';
import './Address.scss';
import { PreviousAddresses } from '../../../popups/PreviousAddresses';
import { getFullDate } from '../../../commons/CommonMethods';
import { ChevronRight } from 'sushiweb/Icons';
import green from 'sushiweb/tokens/color/green';
import ServiceableStores from '../ServiceableStores';
import { MetricsForJumboEvent } from '../../../../analytics/constants';
import { FindServiceableMerchantsModalClickEvent } from '../../../../analytics/store-serviceability/events';

const dashboardMode = window.dashboard.mode;

const AddressDetails = React.memo(function ({ orderId }) {
  const [newAddressDetails, setNewAddressDetails] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    const getUserAddressesDetails = () => {
      const queryParams = {};
      queryParams['order_id'] = orderId;
      userModel
        .userUpadtedAddressDetails(queryParams)
        .then((response) => {
          if (!response || (response && response.isError === true))
            return setError(response);

          setNewAddressDetails(response);
        })
        .catch((error) => {
          toast.error(error);
        });
    };

    getUserAddressesDetails();
  }, [orderId]);

  if (!newAddressDetails) {
    return <Loader />;
  }

  return (
    <div className='tw-flex-col'>
      {newAddressDetails.map((address, index) => {
        return (
          <div
            key={address?.address + index}
            className='tw-flex tw-bg-grey-100 tw-p-5 tw-rounded-lg tw-justify-between tw-items-center tw-mb-1'
          >
            <div className='tw-flex-col tw-mb-1 tw-gap-1'>
              <div className='tw-text-grey-900 tw-text-200 tw-font-semibold tw-mb-1'>
                {address?.address}
              </div>
              {address?.updated_at && (
                <div className='tw-text-grey-700 tw-font-regular tw-text-200'>
                  <span className='tw-font-medium tw-text-200'>
                    Updated At :
                  </span>{' '}
                  {getFullDate(address?.updated_at)}
                </div>
              )}
              {address?.latitude && address?.longitude && (
                <button
                  type='button'
                  className='tw-flex tw-gap-2 tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer'
                  onClick={() => window.open(`http://maps.google.com/?q=${address?.latitude},${address?.longitude}`, '_blank', 'noopener,noreferrer')}
                >
                  <span className='tw-text-grey-700 tw-font-regular tw-text-200'>
                    <span className='tw-font-medium tw-text-200'>
                      Latitude :
                    </span>{' '}
                    {address?.latitude}
                  </span>
                  <span className='tw-text-grey-700 tw-font-regular tw-text-200'>
                    <span className='tw-font-medium tw-text-200'>
                      Longitude :
                    </span>{' '}
                    {address?.longitude}
                  </span>
                  <span className='icon tw-w-5 tw-h-5 '>
                    <img src={upArrowIconGreen} alt='' />
                  </span>
                </button>
              )}
            </div>
            <div
              className={`tw-flex ${
                address?.updated
                  ? ' tw-bg-green-700 tw-text-base-white '
                  : 'tw-bg-grey-200 tw-text-grey-700'
              } tw-h-fit tw-py-1 tw-px-2 tw-rounded-md tw-text-100 tw-font-semibold`}
            >
              {address?.updated ? 'Updated' : 'Old Address'}
            </div>
          </div>
        );
      })}
    </div>
  );
});

export default function Address(props) {
  const [
    {
      address,
      view_on_map,
      show_check_serviceable_store,
      show_find_serviceable_merchants_popup,
      id,
    },
    setUser,
  ] = useState({});

  useEffect(() => {
    const getUserData = () => {
      let queryStrings = {};
      queryStrings['order_id'] = props.orderId;
      userModel.getUserData(queryStrings).then((response) => {
        if (!response || response?.isError) return null;
        setUser(response);
      });
    };

    getUserData();
  }, [props.orderId, props.userId]);

  return (
    <div className='addressContainer'>
      {!(address && props.order) ? (
        <Shimmer height='120px' width='100%' />
      ) : (
        <AddressComp
          {...props}
          address={address}
          viewOnMap={view_on_map}
          checkServiceableMerchants={show_check_serviceable_store}
          showFindServiceableMerchantsPopup={
            show_find_serviceable_merchants_popup
          }
          userId={id}
        />
      )}
    </div>
  );
}
class AddressComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userAddress: '',
      showPreviousAddressPopUp: false,
      showUpdatedAddressPopUp: false,
      showServiceableMerchantsPopUp: false,
    };
  }

  openGoogleMap = () => {
    const { mapInfo } = this.props;
    let str_map_url = '';
    if (mapInfo) {
      const { trace_coordinates } = mapInfo;
      const keys = Object.keys(trace_coordinates);
      if (keys && keys.length === 2) {
        const { from, to } = trace_coordinates;
        let from_latitude = from.latitude,
          from_longitude = from.longitude,
          to_latitude = to.latitude,
          to_longitude = to.longitude;
        str_map_url =
          'https://www.google.com/maps/dir/' +
          from_latitude +
          ',' +
          from_longitude +
          '/' +
          to_latitude +
          ',' +
          to_longitude;
        window.open(str_map_url, '_blank');
      } else if (keys && keys.length === 1) {
        let latitude = trace_coordinates[keys[0]].latitude,
          longitude = trace_coordinates[keys[0]].longitude;
        str_map_url =
          'https://www.google.com/maps/place/' + latitude + ',' + longitude;
        window.open(str_map_url, '_blank');
      } else {
        alert('No data available!');
      }
    } else {
      alert('No data available!');
    }
  };

  renderViewOnMapTemp = () => {
    let url = this.props.viewOnMap;

    return (
      <p
        tabIndex='0'
        role='button'
        css={
          !url &&
          `
          color: #828282;
        `
        }
        className={`${
          url ? 'colorGreen' : ''
        } tw-text-300 tw-font-medium tw-cursor-pointer viewMap`}
        onClick={() =>
          url
            ? window.open(url, '_blank')
            : toast.error(
                'You dont have access to view on map. please reach out to your POC',
              )
        }
        // onClick={this.openGoogleMap}
      >
        View on map
        <span className='iconMarginL icon'>
          <img src={url ? upArrowIconGreen : upArrowIcon} alt='' />
        </span>
      </p>
    );
  };
  renderAddress = (address, latitude, longitude) => {
    if (!address) return null;
    let charLimit = dashboardMode === 'smartplug' ? 60 : 90;
    return (
      <div className='tw-flex-col tw-gap-2' data-dd-privacy='mask'>
        <ShortenedText text={address} charLimit={charLimit} />
        {latitude && longitude && (
          <button
            type='button'
            className='tw-flex tw-gap-2 tw-items-center tw-justify-left tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer'
            onClick={() => window.open(`http://maps.google.com/?q=${latitude},${longitude}`, '_blank', 'noopener,noreferrer')}
          >
            <div className='tw-flex tw-gap-2'>
              <div
                className='tw-text-grey-700 tw-font-regular tw-text-200'
                data-dd-privacy='mask'
              >
                <span className='tw-font-semibold tw-text-200 tw-mr-1'>
                  Lat :
                </span>
                {latitude?.toFixed(4)}
              </div>
              <div
                className='tw-text-grey-700 tw-font-regular tw-text-200'
                data-dd-privacy='mask'
              >
                <span className='tw-font-semibold tw-text-200 tw-mr-1'>
                  Lng :
                </span>
                {longitude?.toFixed(4)}
              </div>
            </div>
            <span className='icon tw-w-4 tw-h-4 '>
              <img src={upArrowIconGreen} alt='' />
            </span>
          </button>
        )}
      </div>
    );
  };

  unmaskAddress = () => {
    const { order } = this.props;
    let queryStrings = {};
    queryStrings['order_id'] = order.order.order_id;
    userModel.unmaskUserInfo(queryStrings, 'address').then((response) => {
      if (!response || (response && response.isError === true)) {
        return toast.error(response.message);
      }

      if (response.status === 'failure') {
        toast.error(
          response.message || 'Something went wrong. please try again later!',
        );
      } else {
        this.setState({
          userAddress: response || '',
        });
      }
    });
  };

  previousAddressesHandler = () => {
    this.setState({
      showPreviousAddressPopUp: true,
    });
  };

  viewAddressDetailsHandler = () => {
    this.setState({
      showUpdatedAddressPopUp: !this.state.showUpdatedAddressPopUp,
    });
  };

  viewMerchantsHandler = () => {
    FindServiceableMerchantsModalClickEvent({
      [MetricsForJumboEvent.order_id]: this.props.orderId,
      [MetricsForJumboEvent.cart_id]: this.props.order?.order?.cart_id,
      [MetricsForJumboEvent.customer_id]: this.props.userId,
    });
    if (!this.props.checkServiceableMerchants)
      return toast.error(
        'You dont have access to view on map. please reach out to your POC',
      );
    this.setState({
      showServiceableMerchantsPopUp: !this.state.showServiceableMerchantsPopUp,
    });
  };

  closeModalHandler = () => {
    this.setState({
      showPreviousAddressPopUp: false,
    });
  };

  render() {
    const { isLog, order, userId } = this.props;
    const { userAddress } = this.state;
    const {
      address_confidence,
      address_confidence_icon,
      address_effort,
      address_effort_icon,
    } = order.order ?? {};
    let centerContent = {};
    centerContent = {
      alignItems: isLog ? 'flex-start' : 'center',
      textAlign: isLog ? 'left' : 'center',
    };

    const { address } = userAddress;

    return (
      <div className='addressinfo' style={centerContent} data-dd-privacy='mask'>
        <div className='addressTitle lighter tw-whitespace-nowrap'>
          Delivery Address
          {userAddress &&
          userAddress.address_confidence &&
          userAddress.address_confidence.length ? (
            <Tooltip
              position='top'
              border={false}
              title={
                <p data-dd-privacy='mask'>
                  <span className='iconMarginL icon'>
                    <img
                      src={
                        userAddress.address_confidence_icon || highAddressIcon
                      }
                      alt=''
                    />
                  </span>
                </p>
              }
              label={userAddress.address_confidence}
              maskData={true}
            />
          ) : null}
          {address_confidence && address_confidence.length ? (
            <Tooltip
              position='top'
              border={false}
              title={
                <p>
                  <span className='iconMarginL icon'>
                    <img
                      src={address_confidence_icon || highAddressIcon}
                      alt=''
                    />
                  </span>
                </p>
              }
              label={address_confidence}
            />
          ) : null}
          {address_effort && address_effort.length ? (
            <Tooltip
              position='top'
              border={false}
              title={
                <p>
                  <span className='iconMarginL icon'>
                    <img src={address_effort_icon || highAddressIcon} alt='' />
                  </span>
                </p>
              }
              label={address_effort}
            />
          ) : null}
          {order?.order?.is_address_updated && (
            <>
              <div
                className={`tw-flex tw-bg-green-200 tw-text-green-700 tw-py-1 tw-px-2 tw-rounded-md tw-text-[9px] tw-whitespace-nowrap tw-font-semibold tw-items-center ${
                  order?.order?.has_address_access ? 'tw-cursor-pointer' : ''
                }`}
                onClick={
                  order?.order?.has_address_access
                    ? this.viewAddressDetailsHandler
                    : () => {}
                }
              >
                Updated
                {order?.order?.has_address_access && (
                  <ChevronRight size={13} color={green.z700} />
                )}
              </div>
            </>
          )}
        </div>
        <div className='addressText normal' style={centerContent}>
          {address && address.length ? (
            this.renderAddress(
              userAddress?.address,
              userAddress?.latitude,
              userAddress?.longitude,
            )
          ) : (
            <div className='masked'>
              xxxxxxxxxxxxxxxx
              <span
                className='pointer icon iconMarginL'
                onClick={this.unmaskAddress}
              >
                <img src={viewText} alt='' />
              </span>
            </div>
          )}
        </div>
        {this.renderViewOnMapTemp()}
        {this.props.showFindServiceableMerchantsPopup && (
          <div
            className={`tw-text-300 tw-font-medium tw-cursor-pointer ${
              this.props.checkServiceableMerchants
                ? 'colorGreen'
                : 'tw-text-grey-600 '
            }`}
            onClick={this.viewMerchantsHandler}
          >
            Find Serviceable Merchant(s)
          </div>
        )}
        <div
          className='colorGreen tw-text-300 tw-font-medium'
          onClick={this.previousAddressesHandler}
        >
          Recently Used Address(es)
        </div>
        {this.state.showPreviousAddressPopUp && (
          <Modal
            isVisible
            type='huge'
            title='Recently Used Address(es)'
            maxHeight='70vh'
            handleClose={this.closeModalHandler}
            component={<PreviousAddresses userId={this.props.userId} />}
          />
        )}
        {this.state.showUpdatedAddressPopUp && (
          <Modal
            isVisible
            type='medium'
            title={
              <div className='tw-font-extrabold tw-text-500'>
                Address Details
              </div>
            }
            maxHeight='70vh'
            handleClose={this.viewAddressDetailsHandler}
            component={<AddressDetails orderId={this.props.orderId} />}
          />
        )}
        {this.state.showServiceableMerchantsPopUp && (
          <Modal
            isVisible
            type='medium'
            title={
              <div className='tw-font-medium tw-text-[2rem] tw-text-[#1C1C1C]'>
                Check Store Serviceability
              </div>
            }
            maxHeight='72vh'
            paddingTop='0'
            handleClose={this.viewMerchantsHandler}
            padding={0}
            containerStyles={{ margin: '16px 0 20px 0', padding: '0 20px' }}
            component={
              <ServiceableStores
                orderId={this.props.orderId}
                cartId={this.props.order?.order?.cart_id}
                userId={this.props.userId}
              />
            }
          />
        )}
      </div>
    );
  }
}
